import React from "react";
import SelectTimezone, { getTimezoneProps } from "@capaj/react-select-timezone";

export const getTimezoneInfo = getTimezoneProps;
export default class SelectTimeZoneWraper extends React.Component {
  render() {
    // console.log("this.props.value", this.props.value);
    return (
      <div>
        <SelectTimezone
          ref={comp => {
            if (comp && this.props.value) {
              comp.setState({
                selectedValue: this.props.value
              });
            }
          }}
          // isClearable // allows user to have null value in this select
          // guess // this will fill the input with user's timezone guessed by moment. A "value" prop has always bigger priority than guessed TZ
          onChange={val => {
            console.log(val); // like "Europe/London"
            // if you need to get offset you can use
            // const timezoneProps = getTimezoneProps(val);
            if (this.props.onChange) this.props.onChange(val);
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-timezone/index.js